import * as Yup from "yup";
import { validatePHONE } from "./PHONEvalidation";
import { validateCPF } from "./CPFvalidation";

const name = Yup.string().required("global.schemas.name.required");
const phone = Yup.string()
  .min(11, "global.schemas.phone.min")
  .required("global.schemas.phone.required")
  .test("phone", "global.schemas.phone.test", (value) =>
    validatePHONE(value ?? "")
  );
const email = Yup.string()
  .email("global.schemas.email.invalid")
  .required("global.schemas.email.required");
const cpf = Yup.string()
  .required("global.schemas.cpf.required")
  .test("cpf", "global.schemas.cpf.invalid", (value) =>
    validateCPF(value ?? "")
  );
const account = Yup.string().required("global.schemas.account.required");
const broker_list = Yup.string().required(
  "global.schemas.broker_list.required"
);
const term_of_contract = Yup.boolean().oneOf(
  [true],
  "global.schemas.term_of_contract.required"
);
const commercial_conditions = Yup.boolean().oneOf(
  [true],
  "global.schemas.commercial_conditions.required"
);
const habilit_account = Yup.boolean().oneOf(
  [true],
  "global.schemas.habilit_account.required"
);
const required = Yup.string().required("global.schemas.required");
const requiredNumber = Yup.number()
  .required("global.schemas.requiredNumber.required")
  .moreThan(0, "global.schemas.requiredNumber.moreThan");
const notRequired = Yup.string().notRequired();
const notRequiredBoolean = Yup.boolean().notRequired();
const commonPassword = Yup.string()
  .required("global.schemas.password.required")
  .min(8, "global.schemas.password.min");
const password = Yup.string()
  .required("global.schemas.password.required")
  .min(8, "global.schemas.password.min")
  .matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z 0-9])(?=.{8,})/,
    "global.schemas.password.pattern"
  );
const secondPassword = Yup.string()
  .required("global.schemas.secondPassword.required")
  .oneOf([Yup.ref("password")], "global.schemas.secondPassword.oneOf");

const arrayOfObject = (value: Yup.ObjectShape) =>
  Yup.array().of(Yup.object().shape(value));

type IsRequiredIfProps = {
  nameValidation: string | string[];
  resultValidation: boolean;
};

const stringIsRequiredIf = ({
  nameValidation,
  resultValidation,
}: IsRequiredIfProps) =>
  Yup.string().when(nameValidation, {
    is: resultValidation,
    then: (value) => value.required("global.schemas.required"),
    otherwise: (value) => value.notRequired(),
  });

const numberIsRequiredIf = ({
  nameValidation,
  resultValidation,
}: IsRequiredIfProps) =>
  Yup.number().when(nameValidation, {
    is: resultValidation,
    then: (value) =>
      value
        .moreThan(0, "global.schemas.requiredNumber.moreThan")
        .required("global.schemas.requiredNumber.required"),
    otherwise: (value) => value.notRequired(),
  });

const booleanIsRequiredIf = ({
  nameValidation,
  resultValidation,
}: IsRequiredIfProps) =>
  Yup.boolean().when(nameValidation, {
    is: resultValidation,
    then: (value) => value.required("global.schemas.required"),
    otherwise: (value) => value.notRequired(),
  });

const dateIsRequiredIf = ({
  nameValidation,
  resultValidation,
}: IsRequiredIfProps) =>
  Yup.date().when(nameValidation, {
    is: resultValidation,
    then: (value) => value.required("global.schemas.required"),
    otherwise: (value) => value.notRequired(),
  });

const cepRequired = Yup.string()
  .required("global.schemas.cep.required")
  .matches(/^[0-9]{5}-?[0-9]{3}$/, {
    message: "global.schemas.cep.invalid",
  });

export {
  name,
  phone,
  email,
  cpf,
  account,
  broker_list,
  term_of_contract,
  commercial_conditions,
  habilit_account,
  required,
  requiredNumber,
  notRequired,
  notRequiredBoolean,
  password,
  commonPassword,
  secondPassword,
  arrayOfObject,
  stringIsRequiredIf,
  numberIsRequiredIf,
  booleanIsRequiredIf,
  dateIsRequiredIf,
  cepRequired,
};
